var exports = {
  "SF": "AutocompleteEmoji.module__sectionHeading___dWJWal",
  "yF": "AutocompleteEmoji.module__divider___dWJWal",
  "mI": "AutocompleteEmoji.module__emojiIcon___dWJWal",
  "M9": "AutocompleteEmoji.module__stickerIconWrapper___dWJWal",
  "F1": "AutocompleteEmoji.module__memeIconWrapper___dWJWal",
  "lA": "AutocompleteEmoji.module__stickerIcon___dWJWal",
  "Cu": "AutocompleteEmoji.module__memeIcon___dWJWal",
  "_Q": "AutocompleteEmoji.module__memeVideo___dWJWal",
  "BN": "AutocompleteEmoji.module__audioIconWrapper___dWJWal",
  "iw": "AutocompleteEmoji.module__audioIcon___dWJWal",
};

module.exports = exports;
